// Header.js

function Header() {
    return(
        <header>
            <h1>NHL Team Stats</h1>
        </header>

    )
}

export default Header